import { getRhinoConfig } from '../../init/rhinoConfig';
import { request } from '../../network';
import { getKsAndWaitIfRefreshing } from '../../phoenix/network/deferRefreshKs';

import { cloudFrontConfig } from './cloudFrontConfig';
import { handleCloudFrontErrors } from './handleCloudFrontErrors';

type Params = {
  params?: Record<string, string | number>;
  path: string;
};

export async function requestCloudFront<T>({ path, params }: Params) {
  const ks = await getKsAndWaitIfRefreshing();
  const { isDebug } = getRhinoConfig();

  const { baseUrl, language } = cloudFrontConfig;

  const queryParams = {
    language,
    ...params,
    ...(isDebug && { rhino: '' }),
  };

  try {
    const response = await request<T>({
      url: baseUrl + path,
      headers: {
        Authorization: `Bearer ${ks}`,
      },
      queryParams,
      method: 'get',
    });

    return response;
  } catch (e) {
    handleCloudFrontErrors(e as Error);
  }
}
